import React from "react";
import { connect } from "react-redux";
import {
  Auth,
  FC_ForgetPassword,
  FC_ForgetPassword_Check,
  FC_ForgetPassword_Interface,
  FC_ForgetPassword_Check_Interface,
} from "../../actions";
import { StoreState } from "../../reducers";
import { validateEmail } from "../../utils/validation";
import { Link } from "react-router-dom";
import Alert, { AlertInterface } from "../../components/Alert/Alert";
import ForgetPasswordChange from "./ForgetPasswordChange";
import { MdVerifiedUser } from "react-icons/md";

// props for the component
interface AppProps {
  auth: Auth;
  FC_ForgetPassword: Function;
  FC_ForgetPassword_Check: Function;
}

enum ValueType {
  email = "email",
  phone = "phone",
}
enum errorType {
  main_error,
  main_success,
  address,
  none,
}

interface AppState {
  type: ValueType;
  address: string;
  loading: boolean;
  error: {
    target: errorType;
    msg: string;
  };
  step_two: boolean;
  success: boolean;
}

class _ForgetPassword extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    this.state = {
      type: ValueType.email,
      loading: false,
      address: "",
      error: { target: errorType.none, msg: "" },
      step_two: false,
      success: false,
    };
  }

  handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ): void => {
    this.setState({
      ...this.state,
      error: {
        target: errorType.none,
        msg: "",
      },
      [e.currentTarget.name]: e.target.value,
    } as Pick<AppState, keyof AppState>);
  };

  submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // check for errors
    if (this.state.address.length <= 4) {
      return this.setState({
        error: {
          target: errorType.address,
          msg: "Required",
        },
      });
    }

    if (
      this.state.type === ValueType.email &&
      !validateEmail(this.state.address)
    ) {
      return this.setState({
        error: {
          target: errorType.address,
          msg: "Pleas enter your email",
        },
      });
    }

    this.setState({
      loading: true,
      error: {
        target: errorType.none,
        msg: "",
      },
    });
    // * Reset password
    this.props.FC_ForgetPassword(
      {
        address: this.state.address,
        verify_type: this.state.type,
      } as FC_ForgetPassword_Interface,
      (status: boolean, msg: string) => {
        if (status === true) {
          this.setState({
            loading: false,
            error: {
              target: errorType.none,
              msg: "",
            },
            step_two: true,
          });
        } else {
          this.setState({
            loading: false,
            error: {
              target: errorType.main_error,
              msg: msg,
            },
          });
        }
      }
    );
  };

  //* Reset password reset
  resetPasswordHandler = (data: { code: string; password: string }) => {
    this.setState({ loading: true });
    this.props.FC_ForgetPassword_Check(
      {
        address: this.state.address,
        new_password: data.password,
        verification_code: data.code,
      } as FC_ForgetPassword_Check_Interface,
      (status: boolean, msg: string) => {
        if (status === true) {
          this.setState({
            loading: false,
            error: {
              target: errorType.main_success,
              msg: "Password has been changed",
            },
            success: true,
          });
        } else {
          this.setState({
            loading: false,
            error: { target: errorType.main_error, msg: msg },
          });
        }
      }
    );
  };
  render() {
    return (
      <div className="bg-gray-200-">
        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-24  h-screen flex flex-wrap content-center-">
          <div className=" lg:max-w-7xl- mx-auto ">
            <div className="">
              {this.state.step_two === true ? (
                <div className="">
                  {this.state.success === true ? (
                    <div className="mt-6 text-center animate__animated animate__zoomIn ">
                      <MdVerifiedUser className="text-green-600 text-7xl inline-block" />
                      <h2 className="text-2xl font-bold mt-2 text-green-700">
                        Password updated
                      </h2>
                      <p className="text-gray-500 mt-2">
                        your password has beed updates <br />
                        you can now log-in with your new password
                      </p>
                      <div className="mt-2">
                        <Link
                          to="/login"
                          className="px-4 py-2 bg-green-100 text-green-800 rounded mt-2 hover:bg-green-600 hover:text-white"
                        >
                          Login
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-4">
                      {this.state.error.target === errorType.main_error && (
                        <div className="mx-auto w-full">
                          <Alert
                            title={this.state.error.msg}
                            theme={AlertInterface.danger}
                          />
                        </div>
                      )}
                      {this.state.error.target === errorType.main_success && (
                        <div className="mx-auto w-full">
                          <Alert
                            title={this.state.error.msg}
                            theme={AlertInterface.success}
                          />
                        </div>
                      )}
                      <ForgetPasswordChange
                        submitData={this.resetPasswordHandler}
                        close={() =>
                          this.setState({
                            step_two: false,
                          })
                        }
                        address={this.state.address}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div className="bg-white border border-gray-200 shadow-xl mx-auto px-4 py-5 rounded  mt-6 sm:mx-auto  w-80">
                  <form onSubmit={this.submitHandler}>
                    <h1 className="px-2 font-extrabold text-2xl text-blue-500  pt-2 pb-4">
                      Resset password
                    </h1>

                    {this.state.error.target === errorType.main_error && (
                      <div className="p-2">
                        <Alert
                          title={this.state.error.msg}
                          theme={AlertInterface.danger}
                        />
                      </div>
                    )}

                    {this.state.error.target === errorType.main_success && (
                      <div className="mx-auto w-full">
                        <Alert
                          title={this.state.error.msg}
                          theme={AlertInterface.success}
                        />
                      </div>
                    )}

                    <div className="p-2 mt-1">
                      <div className="">
                        <div className="mb-2 p-2 rounded-md border">
                          <div className=" text-gray-500 text-xs">
                            Chose where you will receive the code.
                          </div>
                          <div className="mr-1  flex">
                            <section className="mr-4">
                              <input
                                type="radio"
                                name="type"
                                value={ValueType.email}
                                checked={this.state.type === ValueType.email}
                                onChange={this.handleChange}
                                id="radio_email"
                              />
                              <label
                                className="ml-0.5 cursor-pointer"
                                htmlFor="radio_email"
                              >
                                Email
                              </label>
                            </section>
                            <section>
                              <input
                                type="radio"
                                name="type"
                                value={ValueType.phone}
                                checked={this.state.type === ValueType.phone}
                                onChange={this.handleChange}
                                id="phone_email"
                              />
                              <label
                                className="ml-0.5 cursor-pointer"
                                htmlFor="phone_email"
                              >
                                Phone
                              </label>
                            </section>

                            {/*  */}
                          </div>
                        </div>

                        <div className="">
                          <label htmlFor="" className="text-gray-500">
                            {this.state.type === ValueType.email
                              ? "email"
                              : "Phone"}{" "}
                            used on your account
                          </label>
                          <input
                            type={
                              this.state.type === ValueType.email
                                ? "email"
                                : "text"
                            }
                            name="address"
                            onChange={this.handleChange}
                            className={`input-white w-20 inline-block  ${
                              this.state.error?.target === errorType.address
                                ? "border-red-500 border-2"
                                : "input-border"
                            }`}
                            placeholder={`${
                              this.state.type === ValueType.email
                                ? "my_email@mail.com"
                                : "0700000000"
                            }`}
                            value={this.state.address}
                            disabled={this.state.loading}
                          />
                          {this.state.error?.target === errorType.address && (
                            <span className="text-red-600">
                              {this.state.error?.msg}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="p-2">
                      <div className="flex ">
                        <div className=" ">
                          <Link
                            to="/login"
                            className="font-bold text-blue-600 underline"
                          >
                            Login
                          </Link>
                        </div>

                        <div className="flex-1  text-right">
                          <button
                            className={`py-2 font-bold  px-8 rounded bg-hero text-white inline-block`}
                            disabled={this.state.loading}
                            type="submit"
                          >
                            {this.state.loading === true ? (
                              <b className="animate__animated animate__fadeIn animate__infinite">
                                Reseting...
                              </b>
                            ) : (
                              "Reset password"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }: StoreState): { auth: Auth } => {
  return { auth: auth };
};

export const ForgetPassword = connect(mapStateToProps, {
  FC_ForgetPassword,
  FC_ForgetPassword_Check,
})(_ForgetPassword);
